import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { Constants } from '../constants';

@Injectable()
export class AuthGuard {

    constructor(
        private router: Router,
    ) { }

}
